import _regeneratorValues from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js";
import _regeneratorKeys from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import refused from "@/views/house/components/update/refused";
import util from "@/libs/util.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  components: {
    refused: refused
  },
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        auth_status: 1
      },
      // 搜索表单

      filterList: [],
      districtList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      remarkDialogVisible: false,
      currentRemarkObj: {},
      refusedVisible: false,
      currentHouseId: null,
      currentUserId: null
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var badgeNumber;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            badgeNumber = document.querySelector("#houseauth .wlc-menu-badge-number");
            if (badgeNumber && badgeNumber.textContent > 0) {
              _this.searchForm.auth_status = 1;
            }
            _this.getData();
            _this.getHouseFilterType();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getAuthRole: function getAuthRole(role) {
      if (role == 1) {
        return "房东";
      } else if (role == 2) {
        return "转租";
      } else if (role == 3) {
        return "商户";
      } else if (role == 5) {
        return "房东家人";
      }
      return "查看";
    },
    goRealName: function goRealName(row) {
      window.open("#/user/real-name?number=".concat(row.auth_info.idcard_number));
    },
    goLandlordAuthRecord: function goLandlordAuthRecord(row) {
      window.open("#/user/auth-landlord?phone=".concat(row.userInfo.phone));
    },
    setRemarkDialog: function setRemarkDialog(row) {
      this.currentRemarkObj = row.userInfo;
      this.remarkDialogVisible = true;
    },
    // 房源审核
    auditHouse: function auditHouse(row, status) {
      var _this2 = this;
      this.$confirm("确认操作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.auditHouse({
                house_id: row.id,
                status: status
              });
            case 1:
              if (!(row.auth_info.version == 2)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 2;
              return _this2.$api.addLandlordAuth({
                userId: row.userInfo.id,
                houseId: row.id,
                authInfoRecordId: row.auth_info.id,
                adminId: util.cookies.get("uuid")
              });
            case 2:
              _this2.$message.success("操作成功");
              _this2.getData();

              // 操作上报
              _this2.$operationLog.push({
                code: "pass",
                houseId: row.id,
                userId: row.userInfo.id,
                operationType: "house"
              });
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))).catch(function () {});
    },
    auditHouseNew: function auditHouseNew(row, status) {
      this.currentHouseId = row.id;
      this.currentUserId = row.userInfo.id;
      this.refusedVisible = true;
    },
    updateItem: function updateItem(row) {
      var params = new URLSearchParams({
        id: row.id,
        userId: row.userInfo.id,
        from: this.$operationLog.editFrom({
          user_type: row.userInfo.user_type,
          status: row.status
        })
      });
      window.open("#/house/update?".concat(params.toString()));
      // this.$router.push({
      //     path: "/house/update",
      //     query: {
      //         id: row.id,
      //         userId: row.userInfo.id,
      //         from: this.$operationLog.editFrom({
      //             user_type: row.userInfo.user_type,
      //             status: row.status,
      //         }),
      //     },
      // });
    },
    getUserDeviceRiskBatch: function getUserDeviceRiskBatch() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var userIds, res, _loop, key, _t, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              userIds = [];
              _this3.tableData.forEach(function (item) {
                if (userIds.indexOf(item.userInfo.id) == -1) {
                  userIds.push(item.userInfo.id);
                }
              });
              _context4.n = 1;
              return _this3.$api.getUserDeviceRiskBatch({
                user_ids: userIds.join(",")
              });
            case 1:
              res = _context4.v;
              _loop = /*#__PURE__*/_regenerator().m(function _loop(key) {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _this3.tableData.forEach(function (item, index) {
                        if (item.userInfo.id == key) {
                          _this3.$set(item, "deviceRiskInfo", res.data[key]);
                        }
                      });
                    case 1:
                      return _context3.a(2);
                  }
                }, _loop);
              });
              _t = _regeneratorKeys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context4.n = 4;
                break;
              }
              key = _t2.value;
              return _context4.d(_regeneratorValues(_loop(key)), 3);
            case 3:
              _context4.n = 2;
              break;
            case 4:
              return _context4.a(2);
          }
        }, _callee3);
      }))();
    },
    getUsersTagList: function getUsersTagList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var userIds, res, _loop2, key, _t3, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              userIds = [];
              _this4.tableData.forEach(function (item) {
                userIds.push(item.userInfo.id);
              });
              _context6.n = 1;
              return _this4.$api.getUsersTagList({
                top: 5,
                user_id: userIds.join(",")
              });
            case 1:
              res = _context6.v;
              _loop2 = /*#__PURE__*/_regenerator().m(function _loop2(key) {
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      _this4.tableData.forEach(function (item) {
                        if (item.userInfo.id == key) {
                          _this4.$set(item, "userTag", res.data[key]);
                        }
                      });
                    case 1:
                      return _context5.a(2);
                  }
                }, _loop2);
              });
              _t3 = _regeneratorKeys(res.data);
            case 2:
              if ((_t4 = _t3()).done) {
                _context6.n = 4;
                break;
              }
              key = _t4.value;
              return _context6.d(_regeneratorValues(_loop2(key)), 3);
            case 3:
              _context6.n = 2;
              break;
            case 4:
              return _context6.a(2);
          }
        }, _callee4);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var price, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.pn = 1;
              }
              if (_this5.searchForm.priceId && _this5.searchForm.priceId.length > 0) {
                price = _this5.searchForm.priceId.split(",");
                _this5.searchForm.minPrice = price[0];
                _this5.searchForm.maxPrice = price[1];
              }
              _this5.searchForm.type = 4; // 认证列表
              _this5.tableLoading = true;
              _context7.n = 1;
              return _this5.$api.getHouseList(_this5.searchForm);
            case 1:
              res = _context7.v;
              _this5.tableData = res.data.list;
              _this5.total = res.data.count;
              _this5.tableLoading = false;
              _this5.getUsersTagList();
              _this5.getUserDeviceRiskBatch();
              _this5.tableData.forEach(function (item) {
                return item.userId = item.userInfo.id;
              });
              _this5.getUserListByIds(_this5.tableData, "userId", "", "newUser");
            case 2:
              return _context7.a(2);
          }
        }, _callee5);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this6.$api.getHouseFilterType();
            case 1:
              res = _context8.v;
              _this6.filterList = res.data;
            case 2:
              return _context8.a(2);
          }
        }, _callee6);
      }))();
    },
    getDistrictList: function getDistrictList() {
      var _this7 = this;
      this.districtList = [];
      if (this.searchForm.cityId && this.searchForm.cityId.length > 0) {
        this.filterList.cityList.forEach(function (item) {
          if (_this7.searchForm.cityId.indexOf(item.id) > -1) {
            _this7.districtList = _this7.districtList.concat(item.item);
          }
        });
      } else {
        this.districtList = [];
      }
    },
    tableRowClassName: function tableRowClassName(_ref2) {
      var row = _ref2.row;
      if (row.isSensitive) {
        return "warning-row";
      }
      if (row.blackIp) {
        return "black-ip-row";
      }
      if (row.censor_status == "block") {
        return "warning-row";
      }
      return "";
    }
  }
};